import { render, staticRenderFns } from "./BookEfileList.vue?vue&type=template&id=ba39774e&"
import script from "./BookEfileList.vue?vue&type=script&lang=js&"
export * from "./BookEfileList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports